// removed by extract-text-webpack-plugin
module.exports = {"page-container":"page-container___14j-y","pageContainer":"page-container___14j-y"};